import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: OfferCouponsStatus = {
  refunded: 0,
  redeemed: 0,
  available: 0
}

export const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    setCoupon: (state, action: PayloadAction<OfferCouponsStatus>) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { setCoupon } = couponSlice.actions

export const couponReducer = couponSlice.reducer
